import { Search } from 'lucide-react';
import React, { ChangeEvent } from 'react';
import { Input } from '@components/ui/input';
import { I18n } from '../../core/i18n';
import { injectTSDI } from '../../core/tsdi';

interface SearchFilterProps {
    initialValue?: string;
    placeholder?: string;
    onChange(value?: string): void;
}

export const SearchFilter = ({
    initialValue,
    placeholder,
    onChange
}: SearchFilterProps) => {
    const { __ } = injectTSDI(I18n);
    const [value, setValue] = React.useState<string>(initialValue || '');

    React.useEffect(() => {
        setValue(initialValue || '');
    }, [initialValue, setValue]);

    React.useEffect(() => {
        onChange(value || undefined);
    }, [value]);

    return (
        <div className="relative w-full max-w-md">
            <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
            <Input
                value={value}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setValue(e.target.value)
                }
                placeholder={placeholder ?? `${__('commons.search')}...`}
                aria-label="search"
                className="h-9 pl-9"
            />
        </div>
    );
};
